class LsfProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.url || this.loading) return;
    this.observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      this.observer.disconnect();
      this.load();
    }, { rootMargin: '300px' });
    this.observer.observe(this);
  }
  disconnectedCallback() { this.observer?.disconnect(); this.request?.abort(); }
  async load() {
    this.loading = true;
    this.request = new AbortController();
    try {
      const response = await fetch(this.dataset.url, { signal: this.request.signal });
      if (!response.ok) throw new Error('Recommendations unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = [...html.querySelectorAll('lsf-product-recommendations')].find(el => el.dataset.section === this.dataset.section);
      if (next && this.isConnected) this.replaceChildren(...next.childNodes);
    } catch (error) {
      // Aucun encart vide ni message d’erreur commercial si le service ne répond pas.
      if (error.name !== 'AbortError') this.replaceChildren();
    } finally {
      this.loading = false;
      delete this.dataset.url;
    }
  }
}
if (!customElements.get('lsf-product-recommendations')) customElements.define('lsf-product-recommendations', LsfProductRecommendations);
